<template>
  <div>
    <p class="mb-4 title">API Flexy</p>
    <v-card
      class="rounded-lg shadow"
      :loading="isLoading"
      :disabled="isLoading"
      elevation="0"
    >
      <v-card-text class="py-5 px-5">
        <v-select
          label="Service Par defaut"
          :items="flexyServices"
          item-value="value"
          item-text="label"
          :error-messages="errors.default_flexy_service"
          v-model="form.default_flexy_service"
          outlined
          @change="serviceChanged()"
        />

        <div v-if="form.default_flexy_service == 'hybrid_flexy'">

          <v-row>
            <v-col>
                <h4 class="mb-4">Ordre des services</h4>
              <v-simple-table elevation="0">
                <template v-slot:default>
                  <draggable
                    tag="tbody"
                    v-model="flexy_orders"
                    :sort="true"
                    @change="orderChanged"
                    :options="{ group: 'services' }"
                  >
                    <tr v-for="item in flexy_orders" :key="item">
                      <td>
                        {{ item }}
                      </td>
                      <td class="font-weight-bold">
                        <span class="handle font-weight-black">&#8597;</span>
                      </td>
                      <td>
                        <v-btn icon class="red" @click="deleteOrderService(item)">
                            <v-icon class="white--text">mdi-delete-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </draggable>
                </template>
              </v-simple-table>
            </v-col>

            <v-col>
                <h4 class="mb-4">Autres services</h4>
              <v-simple-table elevation="0">
                <template v-slot:default>
                  <draggable
                    tag="tbody"
                    v-model="otherSerives"
                    :options="{ group: 'services' }"
                  >
                    <tr v-for="item in otherSerives" :key="item">
                      <td>
                        {{ item }}
                      </td>
                    </tr>
                  </draggable>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { HTTP } from "@/http-common";
import draggable from "vuedraggable";
export default {
  components: { draggable },
  data() {
    return {
      isLoading: true,
      form: {
        default_flexy_service: ""
      },
      flexyServices: [],
      errors: {},
      flexy_orders: [],
    };
  },
  methods: {
    fetchData() {
      console.log("Flexy");

      this.isLoading = true;
      HTTP.get("/v1/settings")
        .then((res) => {
          console.log(res);
          this.isLoading = false;
          this.form.default_flexy_service = res.data.data.FLEXY_SERVICE;
          this.form.flexy_orders = res.data.data.hybrid_flexy_order.split(",");

          this.flexy_orders = res.data.data.hybrid_flexy_order.split(",");

          this.flexyServices = res.data.data.flexyServices;
          console.log(this.flexyServices)
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    orderChanged() {
      HTTP.post("/v1/settings/order_flexy_services", {
        order: this.flexy_orders.join(","),
      })
        .then((res) => {
          this.isLoading = false;
          this.$successMessage = "Ordre mis a jour";
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    serviceChanged() {
      HTTP.post("/v1/settings/default_flexy_services", {
        service: this.form.default_flexy_service,
      })
        .then((res) => {
          this.isLoading = false;
          this.$successMessage = "Service par defaut mis a jour";
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },

    deleteOrderService(service){
        const index = this.flexy_orders.indexOf(service);
        if (index > -1) { // only splice array when item is found
            this.flexy_orders.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.serviceChanged();
    }
    
  },
  computed: {
    otherSerives(){
        var result = [];
        this.flexyServices.forEach(element => {
            if(this.flexy_orders.includes(element.value) == false){
                result.push(element.value);
            }
        });
        return result;
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>